import { useQuery } from 'react-query';

interface Props {
  /** Interval in seconds */
  interval: number;
}

export const useCurrentTime = ({ interval }: Props) => {
  const result = useQuery(
    ['current_time', interval],
    () => new Date().toISOString(),
    {
      refetchInterval: 1000 * interval,
      initialData: new Date().toISOString(),
    }
  );

  return {
    ...result,
    data: result.data || new Date().toISOString(),
  };
};
